/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MetricValuesPaginationRequestDto
 */
export interface MetricValuesPaginationRequestDto {
    /**
     * Page number
     * @type {number}
     * @memberof MetricValuesPaginationRequestDto
     */
    page?: number;
    /**
     * Page size
     * @type {number}
     * @memberof MetricValuesPaginationRequestDto
     */
    pageSize?: number;
    /**
     * Start date for filtering metric values (ISO 8601 format)
     * @type {string}
     * @memberof MetricValuesPaginationRequestDto
     */
    startDate?: string;
    /**
     * End date for filtering metric values (ISO 8601 format)
     * @type {string}
     * @memberof MetricValuesPaginationRequestDto
     */
    endDate?: string;
    /**
     * Timezone offset in HHMM format (e.g. +0700 for UTC+7, -0500 for UTC-5). When set with date-only startDate/endDate, those dates are interpreted in this timezone.
     * @type {string}
     * @memberof MetricValuesPaginationRequestDto
     */
    timezoneOffset?: string;
    /**
     * Filter by specific metric code
     * @type {string}
     * @memberof MetricValuesPaginationRequestDto
     */
    metricCode: MetricValuesPaginationRequestDtoMetricCodeEnum;
    /**
     * Filter by specific health provider code
     * @type {string}
     * @memberof MetricValuesPaginationRequestDto
     */
    healthProviderCode?: MetricValuesPaginationRequestDtoHealthProviderCodeEnum;
    /**
     * Order results by startDate
     * @type {string}
     * @memberof MetricValuesPaginationRequestDto
     */
    orderBy?: MetricValuesPaginationRequestDtoOrderByEnum;
    /**
     * Hour (0–23) used as the day boundary for filtering. When set, records are filtered by endDate shifted back by (24 - dayBoundaryHour) hours, so sessions are attributed to the day whose boundary window their endDate falls into. Use 19 for 7pm sleep window attribution.
     * @type {number}
     * @memberof MetricValuesPaginationRequestDto
     */
    dayBoundaryHour?: number;
}


/**
 * @export
 */
export const MetricValuesPaginationRequestDtoMetricCodeEnum = {
    StepCounts: 'step-counts',
    Distance: 'distance',
    ActiveCalories: 'active-calories',
    Workouts: 'workouts',
    FloorClimbed: 'floor-climbed',
    HeartRate: 'heart-rate',
    HeartRateVariability: 'heart-rate-variability',
    BloodOxygenSaturation: 'blood-oxygen-saturation',
    RespiratoryRate: 'respiratory-rate',
    RestingHeartRate: 'resting-heart-rate',
    BasalMetabolicRate: 'basal-metabolic-rate',
    BodyTemperature: 'body-temperature',
    BloodPressure: 'blood-pressure',
    BloodGlucose: 'blood-glucose',
    Weight: 'weight',
    Height: 'height',
    WaistCircumference: 'waist-circumference',
    HipCircumference: 'hip-circumference',
    BodyMassIndex: 'body-mass-index',
    BodyFatPercentage: 'body-fat-percentage',
    LeanBodyMass: 'lean-body-mass',
    BoneMass: 'bone-mass',
    SleepAnalysis: 'sleep-analysis',
    SleepStages: 'sleep-stages',
    SleepSessionEvents: 'sleep-session-events',
    TimeInBed: 'time-in-bed',
    SleepTime: 'sleep-time',
    ActualSleepTime: 'actual-sleep-time',
    Nutrition: 'nutrition',
    Calories: 'calories',
    Protein: 'protein',
    Carbohydrates: 'carbohydrates',
    TotalFat: 'total-fat',
    SaturatedFat: 'saturated-fat',
    MonounsaturatedFat: 'monounsaturated-fat',
    PolyunsaturatedFat: 'polyunsaturated-fat',
    Cholesterol: 'cholesterol',
    Micronutrients: 'micronutrients',
    Hydration: 'hydration',
    Menstruation: 'menstruation',
    OvulationTestResults: 'ovulation-test-results',
    WellBeing: 'well-being'
} as const;
export type MetricValuesPaginationRequestDtoMetricCodeEnum = typeof MetricValuesPaginationRequestDtoMetricCodeEnum[keyof typeof MetricValuesPaginationRequestDtoMetricCodeEnum];

/**
 * @export
 */
export const MetricValuesPaginationRequestDtoHealthProviderCodeEnum = {
    AppleHealthkit: 'apple-healthkit',
    GoogleHealthConnect: 'google-health-connect'
} as const;
export type MetricValuesPaginationRequestDtoHealthProviderCodeEnum = typeof MetricValuesPaginationRequestDtoHealthProviderCodeEnum[keyof typeof MetricValuesPaginationRequestDtoHealthProviderCodeEnum];

/**
 * @export
 */
export const MetricValuesPaginationRequestDtoOrderByEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type MetricValuesPaginationRequestDtoOrderByEnum = typeof MetricValuesPaginationRequestDtoOrderByEnum[keyof typeof MetricValuesPaginationRequestDtoOrderByEnum];


/**
 * Check if a given object implements the MetricValuesPaginationRequestDto interface.
 */
export function instanceOfMetricValuesPaginationRequestDto(value: object): value is MetricValuesPaginationRequestDto {
    if (!('metricCode' in value) || value['metricCode'] === undefined) return false;
    return true;
}

export function MetricValuesPaginationRequestDtoFromJSON(json: any): MetricValuesPaginationRequestDto {
    return MetricValuesPaginationRequestDtoFromJSONTyped(json, false);
}

export function MetricValuesPaginationRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetricValuesPaginationRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
        'timezoneOffset': json['timezoneOffset'] == null ? undefined : json['timezoneOffset'],
        'metricCode': json['metricCode'],
        'healthProviderCode': json['healthProviderCode'] == null ? undefined : json['healthProviderCode'],
        'orderBy': json['orderBy'] == null ? undefined : json['orderBy'],
        'dayBoundaryHour': json['dayBoundaryHour'] == null ? undefined : json['dayBoundaryHour'],
    };
}

export function MetricValuesPaginationRequestDtoToJSON(json: any): MetricValuesPaginationRequestDto {
    return MetricValuesPaginationRequestDtoToJSONTyped(json, false);
}

export function MetricValuesPaginationRequestDtoToJSONTyped(value?: MetricValuesPaginationRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'page': value['page'],
        'pageSize': value['pageSize'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'timezoneOffset': value['timezoneOffset'],
        'metricCode': value['metricCode'],
        'healthProviderCode': value['healthProviderCode'],
        'orderBy': value['orderBy'],
        'dayBoundaryHour': value['dayBoundaryHour'],
    };
}

